import React, { useState } from 'react';
import { ExternalLinkIcon, FileTextIcon, MailIcon, PlayIcon } from 'lucide-react';
export function MediaAndInfoSection() {
  const [activeMedia, setActiveMedia] = useState<'image' | 'video'>('image');
  const imageSrc = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=5369&user=2288&w=500&h=500&file=uploaded%2Fimages%2FSPINNER%2FPD%20Series%201.png400x400.png';
  const videoSrc = 'https://www.youtube.com/embed/6HwgUUI9hJw?si=eDkVSWwj4qko4nX7&wmode=opaque';
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-3516">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0" data-id="element-3517">
        {/* Left Column: Media Gallery */}
        <div className="p-8 border-b lg:border-b-0 lg:border-r border-gray-200 bg-gray-50/50" data-id="element-3518">
          <div className="aspect-square bg-white rounded-xl border border-gray-200 overflow-hidden mb-6 flex items-center justify-center shadow-inner" data-id="element-3519">
            {activeMedia === 'image' ? <img src={imageSrc} alt="SPINNER PD" className="max-w-full max-h-full object-contain p-4 block" data-id="element-3520" /> : <iframe src={videoSrc} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-3521"></iframe>}
          </div>

          <div className="flex gap-4" data-id="element-3522">
            <button onClick={() => setActiveMedia('image')} className={`w-24 h-24 rounded-lg border-2 overflow-hidden bg-white transition-all ${activeMedia === 'image' ? 'border-orange ring-2 ring-orange/20' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-3523">
              <img src={imageSrc} alt="Thumbnail" className="w-full h-full object-contain p-2 block" data-id="element-3524" />
            </button>
            <button onClick={() => setActiveMedia('video')} className={`w-24 h-24 rounded-lg border-2 overflow-hidden bg-gray-900 relative flex items-center justify-center group transition-all ${activeMedia === 'video' ? 'border-orange ring-2 ring-orange/20' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-3525">
              <img src={`https://img.youtube.com/vi/6HwgUUI9hJw/hqdefault.jpg`} alt="Video Thumbnail" className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity block" data-id="element-3526" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-3527">
                <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform" data-id="element-3528">
                  <PlayIcon className="w-5 h-5 text-white fill-white ml-1" data-id="element-3529" />
                </div>
              </div>
            </button>
          </div>
        </div>

        {/* Right Column: Product Info */}
        <div className="p-8 lg:p-12 flex flex-col" data-id="element-3530">
          <div className="mb-2" data-id="element-3531">
            <span className="inline-block px-3 py-1 bg-blue-100 text-navy text-xs font-bold uppercase tracking-wider rounded-full mb-4" data-id="element-3532">
              CNC Turning Center
            </span>
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS/Spinner%20Logo.jpg" alt="Spinner Logo" className="h-8 mb-6 block" data-id="element-3533" />
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-3534">
            SPINNER PD
          </h1>
          <h2 className="text-xl text-blue font-medium mb-6" data-id="element-3535">
            Compact microturning center for small precision parts
          </h2>

          <div className="prose prose-gray max-w-none mb-10 text-gray-600" data-id="element-3536">
            <p data-id="element-3537">
              SPINNER PD Ultra-Precision Lathe offers the highest precision in a
              compact machine design.
            </p>
            <p data-id="element-3538">
              More than 3,000 machines are delivered all around the world for:
            </p>
            <ul className="list-disc pl-5 space-y-1 mt-2 mb-4" data-id="element-3539">
              <li data-id="element-3540">Micro machining</li>
              <li data-id="element-3541">Hardturning of small workpieces</li>
              <li data-id="element-3542">Diamond cutting</li>
              <li data-id="element-3543">Mass production with Automation</li>
            </ul>
            <p data-id="element-3544">
              in applications for fine mechanics, optics, electronics,
              automotive and research.
            </p>
          </div>

          <div className="mt-auto space-y-4" data-id="element-3545">
            <a href="/ContactPeakMachineSales.html?i515589:default[Product%20Title]=SPINNER%20PD32" className="flex items-center justify-center w-full bg-navy text-white py-4 px-6 rounded-xl font-bold text-lg hover:bg-orange transition-colors shadow-md hover:shadow-lg" data-id="element-3546">
              <MailIcon className="w-5 h-5 mr-2" data-id="element-3547" />
              Request Quote
            </a>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-3548">
              <div className="relative" data-id="element-3549">
                <a href="https://spinnernorthamerica.com/equipment/7669303-spinner-pd32-cnc-lathes" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full h-full bg-white border-2 border-gray-200 text-navy py-3 px-4 rounded-xl font-bold hover:border-navy hover:bg-gray-50 transition-colors" data-id="element-3550">
                  <ExternalLinkIcon className="w-4 h-4 mr-2" data-id="element-3551" />
                  Discover More
                </a>
              </div>

              <a href="https://www.peakedm.com/uploaded/files/SPINNER/PD%20-%20Ultra-Precision%20Lathe.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full bg-white border-2 border-gray-200 text-navy py-3 px-4 rounded-xl font-bold hover:border-navy hover:bg-gray-50 transition-colors" data-id="element-3552">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-3553" />
                Download Brochure
              </a>
            </div>
            <p className="text-xs text-center text-gray-500 mt-2 italic" data-id="element-3554">
              * Discover More links to the manufacturer's 3rd party website
            </p>
          </div>
        </div>
      </div>
    </div>;
}